import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("ti_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("ti_token");
    if (token && !user) {
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("ti_user", JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem("ti_token");
        localStorage.removeItem("ti_user");
      });
    }
    // eslint-disable-next-line
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("ti_token", r.data.token);
      localStorage.setItem("ti_user", JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const register = async (payload) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/register", payload);
      localStorage.setItem("ti_token", r.data.token);
      localStorage.setItem("ti_user", JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem("ti_token");
    localStorage.removeItem("ti_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
